/* eslint-disable react/prop-types */ // TODO: add props
import { Component } from 'react';

class YouTubeVideo extends Component {
  render() {
    return (
      <a
        href={this.props.url}
        id="youtube-chunk"
        style={this.props.style}
        target="_blank"
        rel="noopener noreferrer"
      >
        <p>
          View on: <b>Youtube</b>
        </p>
        <p>{this.props.url}</p>
        <p className="instructions">
          After you watch this video on Youtube return here and click through to
          the next Edrolo video.
        </p>
      </a>
    );
  }
}

export default YouTubeVideo;
